function setShowMoreInfo(showMoreId, moreText, lessText) {
  if (!showMoreId || !moreText || !lessText) return;

  showMoreId.addEventListener('click', (event) => {
    // Prevent the event from bubbling up
    event.stopPropagation();
    if (!event.target.classList.contains('read-more')) return;
    // Use a flag to prevent multiple executions
    if (event.target.dataset.toggled === 'true') return;
    event.target.dataset.toggled = 'true';

    event.target.parentElement.classList.toggle('active');
    const panel = event.target.previousElementSibling;

    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      event.target.textContent = moreText;
    } else {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
      event.target.textContent = lessText;
    }
    // Reset the flag after the event loop completes
    setTimeout(() => {
      event.target.dataset.toggled = 'false';
    }, 0);
  });
}

window.setShowMoreInfo = setShowMoreInfo;
